import { Component } from '@angular/core';

@Component({
    selector: 'op-special-service-content',
    templateUrl: './special-service-content.component.html'
})
export class SpecialServiceContentComponent { 
}
